import { styled } from '@mui/material/styles';
import some from 'lodash/some';
import React, { FC, memo, useMemo } from 'react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import Drawer from 'Components/Drawer/Drawer';
import DrawerContent from 'Components/Drawer/DrawerContent';
import useDrawerState from 'hooks/useDrawerState';

const Container = styled('div')({
  display: 'flex',
});

const Main = styled('main')(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  flexGrow: 1,
  padding: theme.spacing(3),
  minHeight: '100vh',
}));

// some routes do not allow expanding of drawer for layout issues
const COLLAPSED_DRAWER_ROUTES = ['/products/active/:id/editor'];

const Layout: FC = () => {
  const { drawerOpen, toggleDrawer } = useDrawerState();
  const { pathname } = useLocation();

  const drawerCollapsed = useMemo(
    () => some(COLLAPSED_DRAWER_ROUTES, path => !!matchPath(path, pathname)),
    [pathname]
  );

  return (
    <>
      <Container>
        <Drawer open={!drawerCollapsed && drawerOpen}>
          <DrawerContent
            disableExpand={drawerCollapsed}
            drawerExpanded={!drawerCollapsed && drawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </Drawer>
        <Main>
          <Outlet />
        </Main>
      </Container>
    </>
  );
};

export default memo(Layout);
